import * as S from "./styles";

const Description = ({ children, dark }) => {
  return <S.Description dark={dark}>{children}</S.Description>;
};

export default Description;
